module.exports = __webpack_public_path__ + "img/image1.34ecf044.jpg";